import { CheckWithMetadata } from '@src/types/checks'
import { createStandardAction } from 'typesafe-actions'
import { CheckerError, PusherData } from './types'

interface PusherConnectedPayload {
  appKey: string
  cluster: string
  channelName?: string
}

export interface PusherPlagiarismBasePayload {
  origin?: string
  isPlagiarism?: boolean
  isRecheck?: boolean
}

export interface PusherAnalyzePayload extends PusherPlagiarismBasePayload {
  traceId: string
}

const OPEN_PUSHER_CONNECTION = 'pusher/OPEN_PUSHER_CONNECTION'
const PUSHER_CONNECTED = 'pusher/PUSHER_CONNECTED'
const PUSHER_DISCONNECTED = 'pusher/PUSHER_DSCONNECTED'
const PUSHER_PLAGIARISM_ANALYZE = 'pusher/PUSHER_PLAGIARISM_ANALYZE'
const PUSHER_PARTIAL_PLAGIARISM_ANALYZE = 'pusher/PUSHER_PARTIAL_PLAGIARISM_ANALYZE'
const HANDLE_PUSHER_MESSAGE = 'pusher/HANDLE_PUSHER_MESSAGE'

export const CREATE_PUSHER_CHANNEL = 'pusher/CREATE_PUSHER_CHANNEL'

const PUSHER_ANALYZE = 'pusher/PUSHER_ANALYZE'

const PUSHER_HANDLE_CHECKS = 'pusher/PUSHER_HANDLE_CHECKS'
const PUSHER_HANDLE_CHECKER_ERRORS = 'pusher/PUSHER_HANDLE_CHECKER_ERRORS'

const PUSHER_AUTH_ERROR = 'pusher/PUSHER_AUTH_ERROR'
export const openPusherConnection = createStandardAction(OPEN_PUSHER_CONNECTION)<
  PusherPlagiarismBasePayload
>()

export const pusherConnected = createStandardAction(PUSHER_CONNECTED)<
  PusherConnectedPayload
>()

export const pusherDisconnected = createStandardAction(PUSHER_DISCONNECTED)()

export const createPusherChannel = createStandardAction(CREATE_PUSHER_CHANNEL)<
  PusherPlagiarismBasePayload
>()

export const pusherHandleChecks = createStandardAction(PUSHER_HANDLE_CHECKS)<
  CheckWithMetadata
>()

export const pusherAnalyze = createStandardAction(PUSHER_ANALYZE)<PusherAnalyzePayload>()
export const pusherPlagiarismAnalyze = createStandardAction(PUSHER_PLAGIARISM_ANALYZE)<
  PusherAnalyzePayload
>()
export const pusherPartialPlagiarismAnalyze = createStandardAction(
  PUSHER_PARTIAL_PLAGIARISM_ANALYZE
)<PusherAnalyzePayload>()

export const pusherAuthError = createStandardAction(PUSHER_AUTH_ERROR)()
export const handlePusherMessage = createStandardAction(HANDLE_PUSHER_MESSAGE)<
  PusherData<CheckWithMetadata>
>()

export const handleCheckerErrors = createStandardAction(PUSHER_HANDLE_CHECKER_ERRORS)<
  CheckerError
>()



// WEBPACK FOOTER //
// ./src/state/pusher/actions.ts